<div *ngIf="ishow"> 
    <skill-detail [userInfo]="userInfo"></skill-detail>
    <accomplishment [userInfo]="userInfo"></accomplishment>
</div>